
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's332accee81fd98e1': `Vorheriger slide`,
's768baa30fdf99a45': `Nächster slide`,
    };
  